import DeleteAction from './DeleteAction';
import Lesson from '@/models/Lesson';
import CoursePath from '@/models/CoursePath';
import LessonBlock from '@/models/_deprecated/LessonBlock';

type LessonActionsProps = {
  lesson: Lesson;
  coursePath?: CoursePath;
  block?: LessonBlock;
};

export default function LessonActions({
  lesson,
  coursePath,
  block,
}: LessonActionsProps) {
  if (!coursePath) {
    return null;
  }
  return (
    <nav className="flex gap-2">
      <DeleteAction lesson={lesson} coursePath={coursePath} block={block} />
    </nav>
  );
}
